module.exports = __webpack_public_path__ + "media/images/client-4-0fb8e8d406f5326e4c9edb7fc76474fb.png";